// src/firebase.js (ejemplo robusto)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALSWEvbrkbP3ain4zEOHu8mEGEyhMVoMU",
  authDomain: "screendo-fd1d5.firebaseapp.com",
  databaseURL: "https://screendo-fd1d5-default-rtdb.firebaseio.com",
  projectId: "screendo-fd1d5",
  storageBucket: "screendo-fd1d5.firebasestorage.app",
  messagingSenderId: "88151270241",
  appId: "1:88151270241:web:75e4ed51ed85dde427db20"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app); // 👈 ahora exporta storage también